<template>
  <div class="app">
    <div class="app-content">404 - Page not found</div>
  </div>
</template>

<script>
export default {
  layout: "blank",
  name: "pageNotFound",
};
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  height: 100vh;
  overflow: hidden;

  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    font-size: 50px;
    text-align: center;

    footer {
      margin-top: auto;
    }
  }

  .app-content {
    background-color: $bg-light;
    margin-right: auto;
    margin-left: auto;
    width: auto;
  }
}

@media only screen and (max-width: 1200px) {
  .app {
    &-content {
      margin-left: 3.5rem;
    }
  }
}
</style>
